import React from "react";
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import checkPermissions from '../../shared/checkPermissions';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import axios from 'store/axios/axios-templates';
import { clone, handleError } from "../../shared/utility";
import { templateTypes } from "../../containers/Templates/TemplatesModel";
import TemplatesList from "../../containers/Templates/TemplatesList";
import Loader from "../../components/Loader/Loader";
import TemplateForm from "../../containers/Templates/TemplateForm";
import Button from "../../components/CustomButtons/Button";
import { defaultTemplateEntry } from "../../containers/Templates/TemplatesModel";
import NotificationFixedTop from "../../components/Notification/NotificationFixedTop";

class TemplatesPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        openedEditor: false,
        templateEntry: null,
        templates: [],
        loading: false,
        status: 'ERTL', // or ERTL
        showForm: false,
        notification: '',
        pma_default_id: null,
        ertl_default_id: null,
        default_entry: null
    }
  }

  setNotification = (notification) => { this.setState({notification}) }

  open = (templateEntry) => { this.setState({ templateEntry, showForm: true })}
  close = () => { 
    this.setState({ templateEntry: null, showForm: false })
  } 

  getDefault = async (type) => {
    try {
        const response = await axios.get('/default?type='+type);
        console.log('getting '+ type, response.data);
        if (response.data) {
            const id = response.data.id;
            if (id) {
                const response2 = await axios.get('/entries?id='+id);
                let default_template = null;
                if (response2.data) {
                    default_template = response2.data;
                }
                if (type === 'ERTL') {
                    const obj = { ertl_default_id: id }
                    if (default_template) obj.default_entry = default_template;
                    this.setState(obj)
                } else if (type === 'PMA') {
                    const obj = { pma_default_id: id }
                    if (default_template) obj.default_entry = default_template;
                    this.setState(obj)
                }
            }
        }
    } catch(e) {
        handleError(e);
    }
  }

  setDefault = async (id) => {
    try {
        const obj = {
            id,
            type: this.state.status
        };
        console.log('setting default', obj);
        await axios.post('/default', obj)
        this.getDefault(this.state.status);
    } catch(e) {
        handleError(e);
    }
  }

  loadTemplates = async (status) => {
    let the_status = '';
    if (!status) {
        the_status = this.state.status;
    } else {
        the_status = status;
    }
    this.setState({ loading: true });
    try {
        await this.getDefault(the_status);
        const response = await axios.get('/entries?type='+the_status);
        if (response.data) {
            console.log('templates', response.data);
            const obj = { 
                templates: response.data, 
                loading: false, 
            };
            if (status) obj.status = status;
            return this.setState(obj);
        }
    } catch(e) {
        handleError(e);
    }
    this.setState({ loading: false });
  }

  createTemplate = async (entry) => {
    try {
        await axios.post('/entry', entry);
        return true;
    } catch(e) {
        handleError(e);
    }
    return false;
  }

  updateTemplate = async (entry) => {
    try {
        await axios.put('/entry', entry);
        return true;
    } catch(e) {
        handleError(e);
    }
    return false;
  }

  deleteTemplate = async (id) => {
    try {
        await axios.delete('/entry?id='+id);
    } catch(e) {
        handleError(e);
    }
  }

  componentDidMount() {
    this.props.checkMaintenanceMode();
    this.loadTemplates(this.state.status);
  }

  render() {
    console.log('TemplatesPage', this.state);

    if (!checkPermissions('Templates')) {
      return <Redirect to="/dashboard" />;
    }
    if (this.props.maintenanceMode === 'yes') return <Redirect to="/components/maintenance_page" />

    return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color={this.state.status === 'ERTL' ? 'success' : 'rose'}
                onClick={() => {
                    this.loadTemplates('ERTL');
                }}
            >
              <div className="pointed">ERTL</div>
            </CardIcon>
            <CardIcon color={this.state.status === 'PMA' ? 'success' : 'rose'}
                onClick={() => {
                    this.loadTemplates('PMA');
                }}
            >
              <div className="pointed">PMA</div>
            </CardIcon>
          </CardHeader>
          <CardBody>
            <h1>{this.state.status} Templates</h1>
            <Button color="primary"
                onClick={() => {
                    const templateEntry = clone(defaultTemplateEntry);
                    templateEntry.type = templateTypes[this.state.status];
                    this.setState({
                        templateEntry,
                        showForm: true
                    })
                }}
            >
                ADD NEW
            </Button>
            {this.state.loading && <Loader center={true} />}
            {!this.state.showForm && <TemplatesList 
                templates={this.state.templates}
                open={this.open}
                delete={async (id) => {
                    await this.deleteTemplate(id);
                    await this.loadTemplates();
                }}
                default={this.state.status === 'ERTL' ? this.state.ertl_default_id : this.state.pma_default_id}
                setDefault={this.setDefault}
                type={this.state.status}
                getDefault={this.getDefault}
            />}
            {this.state.showForm && <TemplateForm
                templateType={this.state.status}
                templateEntry={this.state.templateEntry}
                createTemplate={async (templateEntry) => {
                    const temp = await this.createTemplate(templateEntry);
                    console.log('temp', temp);
                    await this.loadTemplates(this.state.status);
                }}
                updateTemplate={this.updateTemplate}
                close={() => {
                    this.setState({
                        showForm: false
                    })
                }}
                setNotification={(msg) => { this.setNotification(msg) }}
                loadTemplates={this.loadTemplates}
                templates={this.state.templates}
                duplicate={async (entry) => {
                    const dupe = await this.createTemplate(entry);
                    console.log('dupe', dupe);
                    await this.loadTemplates(this.state.status);
                    this.setState({
                        notification: 'Duplicated current template'
                    })
                }}
                default_entry={this.state.default_entry}
            />}
          </CardBody>
        </Card>
      </GridItem>

      {this.state.notification && <NotificationFixedTop 
        open={this.state.notification}
        close={() => {
            this.setState({
                notification: ''
            })
        }}
        message={this.state.notification}
        autoClose={2000}
      />}
    </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    maintenanceMode: state.userPerms.maintenanceMode
  }
}

const mapDispatchToProps = dispatch => {
  return {
    checkMaintenanceMode: () => {
      dispatch(actions.checkMaintenanceMode());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplatesPage);
